import React from 'react';
import { Card, Typography } from 'antd';

const { Title } = Typography;

function AdminBackup() {
    return (
        <div className="p-6">
            <Title level={2}>Backup & Restore</Title>
            <Card>
                <p>Backup and restore functionality coming soon...</p>
            </Card>
        </div>
    );
}

export default AdminBackup;